import React, { ReactElement } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Loader } from 'shared'
import useAuth from '../hooks/Auth'

interface RouteGuardProps {
  children: ReactElement;
  requiredRoles?: string[];
}

const RouteGuard: React.FC<RouteGuardProps> = ({ requiredRoles, children }) => {
  const { role, loadingRole, error } = useAuth()
  const location = useLocation()

  if (loadingRole) {
    return <Loader />
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <h2>Unable to connect to the server.</h2>
        <p>Please check your internet connection or try again later.</p>
      </div>
    )
  }

  if (!role) {
    return <Navigate to="/auth" state={{ from: location }} replace />
  }

  if (
    requiredRoles &&
    !requiredRoles.some((requiredRole) => role.includes(requiredRole))
  ) {
    return <Navigate to="/auth" replace />
  }

  return children
}

export default RouteGuard
